var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoldBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_274_37)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.13274 9L0.196818 2.42551C-0.0678409 2.13253 -0.0651406 1.66376 0.202219 1.37078L1.26356 0.219371C1.53632 -0.07361 1.97381 -0.07361 2.24387 0.2223L9.79745 8.46971C9.93248 8.6162 10 8.80663 10 9C10 9.19337 9.93248 9.3838 9.79745 9.53029L2.24387 17.7777C1.97381 18.0736 1.53632 18.0736 1.26356 17.7806L0.202219 16.6292C-0.0651406 16.3362 -0.0678409 15.8675 0.196818 15.5745L6.13274 9Z",
    fill: "#1D1D1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_274_37"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoldBlack);
export default __webpack_public_path__ + "static/media/bold-black.6d5010b9834aeafed60655e68a0bd279.svg";
export { ForwardRef as ReactComponent };